import React from "react";

import withStyles from '@mui/styles/withStyles';
import classnames from "classnames";

type Props = {
  value?: string;
  backgroundColor?: string;
  dataCy?: string;
  textColor?: string;
  classes?: any;
  className?: string;
};

const styles = () => ({
  customBadge: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: (props: { textColor?: string; backgroundColor?: string }) =>
      props?.backgroundColor,
    maxWidth: "148px",
    width: "fit-content",
    padding: "6px 16px",
    height: "40px",
    borderRadius: "20px",
    cursor: "default",
    minWidth: "51px",
  },
  textValue: {
    color: (props: { textColor?: string }) => props?.textColor,
    fontFamily: "Inter",
    fontSize: "10px",
    fontWeight: 600,
    lineHeight: "16px",
    width: "fit-content",
    overflow: "hidden",
    maxWidth: "148px",
    minWidth: "51px",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap" as unknown as undefined,
    textAlign:"center" as unknown as undefined,
  },
});

const SimpleBadge = (props: Props) => {
  const { classes, value, className, dataCy } = props;

  return (
    <div className={classnames(classes.customBadge, className)}>
      <span className={classes.textValue} data-cy={dataCy}>
        {value}
      </span>
    </div>
  );
};

const StyledBadge = withStyles(styles)(SimpleBadge);

const BadgeSubStatus = (props: Props) => {
  const { value, className, dataCy } = props;

  const renderBadge = (backgroundColor: string, textColor: string, value?: string) => {
    if (value)
      return (
        <StyledBadge
          dataCy={dataCy}
          backgroundColor={backgroundColor}
          textColor={textColor}
          value={value}
          className={className}
        />
      );

    return <> </>;
  };

  switch (value?.toLowerCase()) {
    case "open":
      return renderBadge("#e6fffd", "#00D0BD", value);
    case "booked":
    case "lost":
      return renderBadge("#eafaf9", "#38CFC4", value);
    case "loaded":
    case "new":
      return renderBadge("#dbf0e1", "#50B56C", value);
    case "delivered":
    case "won":
    case "won (draft)":
      return renderBadge("#eaf5fa", "#38A2CF", value);
    case "in progress":
      return renderBadge("#faf1ea", "#CF7738", value);
    case "canceled":
    case "cancelled":
      return renderBadge("#faebeb", "#CF4842", value);
    case "inspect":
      return renderBadge("#e6fffd", "#00D0BD", value);
    case "pending":
      return renderBadge("#fff6e6", "#ffa500", value);
    case "draft":
      return renderBadge("#e6e6e6", "#a0a0a0", value);
    case "review needed":
      return renderBadge("#FEF0C7", "#DC6803", value);
    case "estimate declined":
      return renderBadge("#fbebea", "#CF372C", value);
    case "estimate approved":
      return renderBadge("#e6ffe8", "#00D014", value);
    default:
      return renderBadge("#e6fffd", "#00D0BD", value);
  }
};

export default BadgeSubStatus;
